import {
  DEFAULT_COUNTRY_CODE,
  isCanada,
  isUnitedStates,
} from '@/lib/constants/countries';

const CANADIAN_POSTAL_CODE_PATTERN = /^[A-Z]\d[A-Z]\d[A-Z]\d$/;

/**
 * Formats a postcode for display based on country rules.
 */
export const formatPostcode = (
  postcode: string,
  countryCode: string | null | undefined = DEFAULT_COUNTRY_CODE,
): string => {
  const trimmed = postcode.trim();
  if (!trimmed) {
    return '';
  }

  const country = (countryCode ?? DEFAULT_COUNTRY_CODE).toUpperCase();
  const cleanedPostcode = trimmed.replace(/\s+/g, '').toUpperCase();

  if (isCanada(country)) {
    const normalized = cleanedPostcode.replace(/[^A-Z0-9]/g, '');
    if (CANADIAN_POSTAL_CODE_PATTERN.test(normalized)) {
      return `${normalized.slice(0, 3)} ${normalized.slice(3)}`;
    }
    return trimmed.toUpperCase();
  }

  if (isUnitedStates(country)) {
    const digits = cleanedPostcode.replace(/\D/g, '');
    if (digits.length > 5) {
      return `${digits.slice(0, 5)}-${digits.slice(5, 9)}`;
    }
    return digits.slice(0, 5);
  }

  return trimmed.toUpperCase();
};
